import { ModelSagres } from "@/types/model-sagres";
import { HistoricoManifestacao } from "./historico-manifestacao";
import { ProrrogacaoOuvidoria } from "./prorrogacao-ouvidoria";
import { ArquivosManifestacao } from "./arquivos-manifestacao";
import { Andamento } from "./andamento";
export class Manifestacao extends ModelSagres {
  IdManifestacao: number;
  IdAssunto: number;
  CodStatus: number;
  DataCriacao: Date;
  IdUsuarioManifestante: string;
  Numero: number;
  Ano: number;
  Mensagem: string;
  DataVencimentoInicial: Date;
  DataVencimentoAtualizada: Date;
  DataEncerramento: Date | null;
  CodProtocoloEtce: string | null;
  CodStatusNavigation: string | null;
  IdAssuntoNavigation: any;
  Andamentos: Andamento[] | null;
  ArquivosManifestacaos: ArquivosManifestacao[] | null;
  HistoricoManifests: HistoricoManifestacao[] | null;
  Prorrogacoes: ProrrogacaoOuvidoria[] | null;
  NmAno: string | null;
  Concluida: boolean
  Sigilo: '0' | '1' = '0'

  constructor(obj?: any) {
    super();
    if (obj.IdManifestacao) this.IdManifestacao = obj.IdManifestacao;
    if (obj.IdAssunto) this.IdAssunto = obj.IdAssunto;
    if (obj.CodStatus) this.CodStatus = obj.CodStatus;
    if (obj.DataCriacao) this.DataCriacao = obj.DataCriacao;
    if (obj.IdUsuarioManifestante)
      this.IdUsuarioManifestante = obj.IdUsuarioManifestante;
    if (obj.Numero) this.Numero = obj.Numero;
    if (obj.Ano) this.Ano = obj.Ano;
    if (obj.Mensagem) this.Mensagem = obj.Mensagem;
    if (obj.DataVencimentoInicial)
      this.DataVencimentoInicial = obj.DataVencimentoInicial;
    if (obj.DataVencimentoAtualizada)
      this.DataVencimentoAtualizada = obj.DataVencimentoAtualizada;
    if (obj.DataEncerramento) this.DataEncerramento = obj.DataEncerramento;
    if (obj.CodProtocoloEtce) this.CodProtocoloEtce = obj.CodProtocoloEtce;
    if (obj.CodStatusNavigation)
      this.CodStatusNavigation = obj.CodStatusNavigation;
    if (obj.IdAssuntoNavigation)
      this.IdAssuntoNavigation = obj.IdAssuntoNavigation;
    if (obj.Andamentos) this.Andamentos = obj.Andamentos;
    if (obj.ArquivosManifestacaos)
      this.ArquivosManifestacaos = obj.ArquivosManifestacaos;
    if (obj.HistoricoManifests)
      this.HistoricoManifests = obj.HistoricoManifests;
    if (obj.Prorrogacaos) this.Prorrogacoes = obj.Prorrogacaos;
    if (obj.Sigilo) this.Sigilo = obj.Sigilo;

    this.Concluida = obj.Concluida ?? false

    if (this.Numero && this.Ano) this.NmAno = `${this.Numero}/${this.Ano}`;
  }
}
